module.exports = __webpack_public_path__ + "img/who-1.3f9eb684.png";